"use client";
import arabic from "@/locales/ar.json";
import english from "@/locales/en.json";
import { useEffect, useState } from "react";

export type Language = "en" | "ar";

export const useTranslations = (lang: Language) => {
  const [translations, setTranslations] = useState<any>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTranslations = async () => {
      try {
        setLoading(true);
        // Import the appropriate JSON file based on language
        const translationData = lang === "en" ? english : arabic;
        setTranslations(translationData);
      } catch (error) {
        console.error(`Error loading translations for ${lang}:`, error);
        // Fallback to empty object if translation file fails to load
        setTranslations({});
      } finally {
        setLoading(false);
      }
    };

    loadTranslations();
  }, [lang]);

  const t = (key: string): string => {
    if (loading) return key;

    const keys = key.split(".");
    let value = translations;

    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) return key;
    }

    return value as string;
  };

  return { t, loading };
};
